import { render } from "./AcceptTerms.vue?vue&type=template&id=5556be02&scoped=true"
import script from "./AcceptTerms.vue?vue&type=script&lang=js"
export * from "./AcceptTerms.vue?vue&type=script&lang=js"

import "./AcceptTerms.vue?vue&type=style&index=0&id=5556be02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5556be02"]])

export default __exports__